export default __webpack_public_path__ + "static/media/upload.615e1e40.svg";